export let CallIconStatus;
(function (CallIconStatus) {
  CallIconStatus["ONLINE"] = "ONLINE";
  CallIconStatus["OFFLINE"] = "OFFLINE";
  CallIconStatus["ERROR"] = "ERROR";
  CallIconStatus["BASE_PHONE"] = "BASE_PHONE";
  CallIconStatus["GREEN_FILLED_CIRCLE"] = "GREEN_FILLED_CIRCLE";
  CallIconStatus["EMPTY_CIRCLE"] = "EMPTY_CIRCLE";
  CallIconStatus["GREEN_FILLED_CIRCLE_PULSING"] = "GREEN_FILLED_CIRCLE_PULSING";
  CallIconStatus["SOLID_CROSS"] = "SOLID_CROSS";
})(CallIconStatus || (CallIconStatus = {}));
export const ONLINE = CallIconStatus.ONLINE;
export const OFFLINE = CallIconStatus.OFFLINE;
export const ERROR = CallIconStatus.ERROR;
export const BASE_PHONE = CallIconStatus.BASE_PHONE;
export const GREEN_FILLED_CIRCLE = CallIconStatus.GREEN_FILLED_CIRCLE;
export const EMPTY_CIRCLE = CallIconStatus.EMPTY_CIRCLE;
export const GREEN_FILLED_CIRCLE_PULSING = CallIconStatus.GREEN_FILLED_CIRCLE_PULSING;
export const SOLID_CROSS = CallIconStatus.SOLID_CROSS;